"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/ThumbsUp.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ThumbsUp = function ThumbsUp(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 153.99 158.41"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Thumbs Up Icon"), _react2.default.createElement("path", {
    d: "M149.37 107.69A19.68 19.68 0 0 0 154 94.54a20.2 20.2 0 0 0-4.31-11.4c2.15-5.37 3-13.81-4.21-20.37-5.27-4.8-14.21-7-26.6-6.36a103.91 103.91 0 0 0-16.3 2.09c-1.66.3-3.41.66-5.2 1.06-.13-2.12.23-7.39 4.14-19.25 4.64-14.11 4.37-24.91-.86-32.13C95.11.6 86.33 0 83.74 0a8.32 8.32 0 0 0-6.39 2.91c-3.68 4.27-3.25 12.16-2.78 15.8-4.37 11.73-16.63 40.48-27 48.46a3.55 3.55 0 0 0-.53.46 35.56 35.56 0 0 0-6.49 9.74A13.68 13.68 0 0 0 34 75.73H13.78A13.79 13.79 0 0 0 0 89.51v53.83a13.79 13.79 0 0 0 13.78 13.78H34a13.76 13.76 0 0 0 8-2.52l7.78.93a333.84 333.84 0 0 0 44.16 2.42c3.94.3 7.65.46 11.1.46a74.26 74.26 0 0 0 15.4-1.39c10.14-2.15 17.06-6.46 20.57-12.79a20.28 20.28 0 0 0 2.25-12.69c6.59-6 7.75-12.56 7.52-17.19a22.4 22.4 0 0 0-1.36-6.66zM13.78 148.17a4.84 4.84 0 0 1-4.84-4.84V89.47a4.84 4.84 0 0 1 4.84-4.84H34a4.84 4.84 0 0 1 4.84 4.84v53.83a4.84 4.84 0 0 1-4.84 4.84H13.78zm127.1-44.36a4.45 4.45 0 0 0-.6 5.4 13.79 13.79 0 0 1 1.52 5.53c.23 4.34-1.86 8.18-6.23 11.46a4.51 4.51 0 0 0-1.52 5.1 11.71 11.71 0 0 1-.89 8.55c-2.22 4-7.16 6.82-14.64 8.41-6 1.29-14.14 1.53-24.15.73h-.46a327 327 0 0 1-43.06-2.35l-3.34-.4a14 14 0 0 0 .3-2.91V89.47a14 14 0 0 0-.63-4.11A27.7 27.7 0 0 1 53.3 74c14.87-11.79 29.42-51.58 30-53.3a4.21 4.21 0 0 0 .2-2.22c-.56-3.71-.37-8.25.43-9.61 1.75 0 6.49.53 9.34 4.47 3.38 4.67 3.25 13-.4 24.08-5.56 16.86-6 25.74-1.62 29.65a7.22 7.22 0 0 0 7.22 1.29c2-.46 3.94-.86 5.76-1.16l.43-.1c10.17-2.22 28.39-3.58 34.72 2.19 5.37 4.9 1.56 11.4 1.13 12.09a4.43 4.43 0 0 0 .79 5.76s3.51 3.31 3.68 7.72c.13 2.95-1.26 6-4.14 8.94zm0 0",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = ThumbsUp;